<template>
  <div class="editPass">
    <div class="editPass-header">
      输入新密码
    </div>
    <div class="editPass-body">
      <div class="ps">
        当前密码过于简单，为保护您的账户安全，请尽快修改密码,密码必须包括字母，数字，特殊符号
      </div>
      <input type="password" class="pass-input" v-model="input"/>
      <div class="error-msg">{{error}}</div>

      <button class="pass-btn" type="button" @click="onSubmit">修改</button>
    </div>
  </div>
</template>

<script>
import qs from "qs";

const CryptoJS = require('crypto-js')

function encrypt(data) {
  var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
  key = CryptoJS.enc.Hex.parse(key)
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
  var enc = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  var enced = enc.ciphertext.toString()
  return enced
}

export default {
  data() {
    return {
      input: "",
      error: "",
    }
  },
  methods: {
    onSubmit() {
      this.error = ""
      var reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[~@#$%^&+=!()*]).*$/
      if (!reg.test(this.input)) {
        this.error = this.$t('edit_pass.ps')
        return
      }

      this.$ajax.post("/etv/updatePasswordToSafe.json", qs.stringify({
        password: encrypt(this.input)
      })).then(res => {
        if (res.data.code === 0) {
          this.$ajax.post('/etv/logout.json').then(() => {
            this.$router.push('/login')
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.editPass {
  width: 100%;
  height: 100%;
  padding: 10px 20px;
  box-sizing: border-box;

  .editPass-header {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    margin-bottom: 20px;
  }

  .editPass-body {
    .ps {
      color: red;
      font-size: 14px;
    }

    .pass-input {
      height: 35px;
      width: 100%;
      padding-left: 10px;
      box-sizing: border-box;
      border: 1px solid #c1c1c1;
      outline: none;
      margin-top: 20px;
      border-radius: 3px;
    }

    .error-msg {
      height: 20px;
      font-size: 14px;
      color: red;
    }

    .pass-btn {
      width: 100%;
      height: 35px;
      color: #ffffff;
      outline: none;
      border-radius: 3px;
      background: #1B89FA;
      border: 1px solid #1B89FA;
      margin-top: 30px;
    }
  }
}
</style>
